// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.repeatable {
  margin-bottom: 15px;
}

.ta .offerings .remover {
  font-size: 12px;
  text-decoration: underline;
}

.ta .rosterSpots {
  font-size: 12px;
  float: right !important;
}

.ta .offerings .actor {
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
}

.ta .offerings button.actor {
  background: none;
  border: none;
}

.ta .offerings .actor span {
  text-decoration: underline;
}

.ta .offerings .actor:before {
  content: '+';
  text-decoration: none;
}

.repeatableBody {
  background-color: #e5e5e5;
  padding: 15px;
}

.col-md-12 .panel-group .panel.offering-has-error .panel-heading {
  color: #a94442;
  background-color: #f8d8d6;
  border-color: #ebccd1;
}

.repeater .repeatable .repeatableBody .row.form-inline {
  margin: 15px -15px;
}

.repeater .repeatable .repeatableBody .row.form-inline label {
  margin-right: 7px;
}

.repeater .repeatable .repeatableBody .row.form-inline .form-group {
  margin-right: 15px;
}

.repeater .repeatable hr {
  border-top: 1px solid #ccc;
}

.table h6 {
  font-size: 12px;
  font-weight: bold;
}

.repeater .days {
  float: right;
  margin: 0px;
  padding: 0px;
}

.repeater .days .day {
  background-color: #fff;
  border: 1px solid #ccc;
  border-right: none;
  display: inline-block;
  float: left;
  height: 30px;
  margin: 0px;
  padding: 5px;
  text-align: center;
  width: 30px;
}

.repeater .days .day:first-child {
  border-left: 1px solid #ccc;
}

.repeater .days .day:last-child {
  border-right: 1px solid #ccc;
}

.repeater .days .day.active {
  background-color: #ccc;
}

.repeater .repeatable .repeatableBody {
}

.repeater .repeatable .repeatableBody .row.form-inline {
  margin: 15px -15px;
}

.repeater .repeatable .repeatableBody .row.form-inline label {
  margin-right: 7px;
}

.repeater .repeatable .repeatableBody .row.form-inline .form-group {
  margin-right: 15px;
}

.repeater .repeatable hr {
  border-top: 1px solid #ccc;
}

.table h6 {
  font-size: 12px;
  font-weight: bold;
}

.repeater .days {
  float: right;
  margin: 0px;
  padding: 0px;
}

.repeater .days .day {
  background-color: #fff;
  border: 1px solid #ccc;
  border-right: none;
  display: inline-block;
  float: left;
  height: 30px;
  margin: 0px;
  padding: 5px;
  text-align: center;
  width: 30px;
}

.repeater .days .day:first-child {
  border-left: 1px solid #ccc;
}

.repeater .days .day:last-child {
  border-right: 1px solid #ccc;
}

.repeater .days .day.active {
  background-color: #ccc;
}

.ta .create .spinner {
  margin: 15px auto;
}

.ta .modal-body .row {
  margin-bottom: 15px;
}

.ta .modal-body .row:last-child {
  margin-bottom: 0px;
}

.ta .modal-body .row .iltCount {
  border: 1px solid #ccc;
  padding: 30px 0 15px;
}

.ta .modal-body .iltCount:first-child {
  margin: 0px 30px;
}

.ta .modal-body .row .iltCount p {
  font-size: 16px;
  font-weight: bold;
}

.ta .modal-body .row .iltCount .count {
  color: #999;
  font-size: 36px;
}

.ta .modal-body .container-fluid {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/courses/create.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;AACA;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".repeatable {\n  margin-bottom: 15px;\n}\n\n.ta .offerings .remover {\n  font-size: 12px;\n  text-decoration: underline;\n}\n\n.ta .rosterSpots {\n  font-size: 12px;\n  float: right !important;\n}\n\n.ta .offerings .actor {\n  font-size: 12px;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.ta .offerings button.actor {\n  background: none;\n  border: none;\n}\n\n.ta .offerings .actor span {\n  text-decoration: underline;\n}\n\n.ta .offerings .actor:before {\n  content: '+';\n  text-decoration: none;\n}\n\n.repeatableBody {\n  background-color: #e5e5e5;\n  padding: 15px;\n}\n\n.col-md-12 .panel-group .panel.offering-has-error .panel-heading {\n  color: #a94442;\n  background-color: #f8d8d6;\n  border-color: #ebccd1;\n}\n\n.repeater .repeatable .repeatableBody .row.form-inline {\n  margin: 15px -15px;\n}\n\n.repeater .repeatable .repeatableBody .row.form-inline label {\n  margin-right: 7px;\n}\n\n.repeater .repeatable .repeatableBody .row.form-inline .form-group {\n  margin-right: 15px;\n}\n\n.repeater .repeatable hr {\n  border-top: 1px solid #ccc;\n}\n\n.table h6 {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.repeater .days {\n  float: right;\n  margin: 0px;\n  padding: 0px;\n}\n\n.repeater .days .day {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-right: none;\n  display: inline-block;\n  float: left;\n  height: 30px;\n  margin: 0px;\n  padding: 5px;\n  text-align: center;\n  width: 30px;\n}\n\n.repeater .days .day:first-child {\n  border-left: 1px solid #ccc;\n}\n\n.repeater .days .day:last-child {\n  border-right: 1px solid #ccc;\n}\n\n.repeater .days .day.active {\n  background-color: #ccc;\n}\n\n.repeater .repeatable .repeatableBody {\n}\n\n.repeater .repeatable .repeatableBody .row.form-inline {\n  margin: 15px -15px;\n}\n\n.repeater .repeatable .repeatableBody .row.form-inline label {\n  margin-right: 7px;\n}\n\n.repeater .repeatable .repeatableBody .row.form-inline .form-group {\n  margin-right: 15px;\n}\n\n.repeater .repeatable hr {\n  border-top: 1px solid #ccc;\n}\n\n.table h6 {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.repeater .days {\n  float: right;\n  margin: 0px;\n  padding: 0px;\n}\n\n.repeater .days .day {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-right: none;\n  display: inline-block;\n  float: left;\n  height: 30px;\n  margin: 0px;\n  padding: 5px;\n  text-align: center;\n  width: 30px;\n}\n\n.repeater .days .day:first-child {\n  border-left: 1px solid #ccc;\n}\n\n.repeater .days .day:last-child {\n  border-right: 1px solid #ccc;\n}\n\n.repeater .days .day.active {\n  background-color: #ccc;\n}\n\n.ta .create .spinner {\n  margin: 15px auto;\n}\n\n.ta .modal-body .row {\n  margin-bottom: 15px;\n}\n\n.ta .modal-body .row:last-child {\n  margin-bottom: 0px;\n}\n\n.ta .modal-body .row .iltCount {\n  border: 1px solid #ccc;\n  padding: 30px 0 15px;\n}\n\n.ta .modal-body .iltCount:first-child {\n  margin: 0px 30px;\n}\n\n.ta .modal-body .row .iltCount p {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.ta .modal-body .row .iltCount .count {\n  color: #999;\n  font-size: 36px;\n}\n\n.ta .modal-body .container-fluid {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
